import React from 'react';
import API from '../api';
import { exitImpersonation, getAuthItem } from '../utils/auth';

function decodeJwt(token) {
  try {
    const payload = token.split('.')[1];
    if (!payload) return null;
    return JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
  } catch (e) {
    return null;
  }
}

export default function FloatingExitImpersonation() {
  if (typeof window === 'undefined') return null;
  const token = getAuthItem('token');
  const payload = token ? decodeJwt(token) : null;
  const isImpersonated = payload?.impersonated;

  if (!isImpersonated) return null;

  const handleExit = async () => {
    try {
      console.log('FloatingExitImpersonation: Starting exit...');
      const result = await exitImpersonation(API);
      console.log('FloatingExitImpersonation: Exit completed', result);
    } catch (err) {
      console.error('FloatingExitImpersonation: Exit impersonation failed', {
        error: err,
        message: err?.message,
        stack: err?.stack
      });
      // Don't clear token on error - let exitImpersonation handle the redirect
      // The function will redirect to dashboard even on error
    }
  };

  return (
    <div style={{ position: 'fixed', right: 16, bottom: 16, zIndex: 1000 }}>
      <button
        onClick={handleExit}
        title="Exit impersonation"
        style={{
          background: '#F59E0B',
          color: '#000',
          padding: '10px 14px',
          borderRadius: 999,
          boxShadow: '0 6px 18px rgba(0,0,0,0.12)',
          fontWeight: 600,
        }}
      >
        Exit Impersonation
      </button>
    </div>
  );
}
